<template>
  <div>
    <h3 class="mb-3">Geräte <b-spinner div v-if="loadingMessages" variant="info"></b-spinner></h3>
    <div v-if="geraeteStatus.gettingAlleGeraete">
      <b-spinner variant="dark" type="grow"></b-spinner>
    </div>
    <div v-else-if="adminGeraete.length > 0 && geraetetypen.length > 0" class="mb-5 text-left">
      <b-table sticky-header="400px" striped small responsive outlined :items="adminGeraete" :fields="fields">
        <template v-slot:cell(messages)="data">
          <b-button variant="info" @click="downloadMessages(data.item.sigfoxDeviceId)">
            Herunterladen
          </b-button>
        </template>
      </b-table>
    </div>
    <div v-else>
      <b-alert variant="danger">Es wurden noch keine Gerätetypen angelegt</b-alert>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DataService from '@/service/DataService'

export default {
  name: 'Geraet',
  computed: mapGetters(['adminGeraete', 'geraeteStatus', 'alleBenutzer', 'geraetetypen']),
  methods: {
    ...mapActions(['fetchAlleGeraete']),
    downloadMessages(deviceID) {
      this.loadingMessages = true

      DataService.adminGetDeviceMessagesCSV(deviceID)
        .then(res => {
          const fileName = res.data

          DataService.adminDownloadDeviceMessagesCSV(fileName)
            .then(res => {
              const url = window.URL.createObjectURL(new Blob([res.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', fileName)
              document.body.appendChild(link)
              link.click()

              this.loadingMessages = false
            })
            .catch(() => {
              this.loadingMessages = false

              const toastData = {
                title: "Fehler beim Herunterladen der CSV Datei",
                msg: "Es ist ein Fehler aufgetreten, probiere es später erneut.",
                variant: "warning"
              }

              this.makeToast(toastData)
            })
        })
        .catch(() => {
          this.loadingMessages = false
          const toastData = {
                title: "Fehler beim Erzeugen der CSV Datei",
                msg: "Es ist ein Fehler aufgetreten, probiere es später erneut.",
                variant: "warning"
              }

              this.makeToast(toastData)
        })
    },
    makeToast (toast) {
      this.$bvToast.toast(toast.msg, {
        title: toast.title,
        toaster: 'b-toaster-bottom-full',
        variant: toast.variant,
        autoHideDelay: 7000,
        appendToast: true,
        solid: true
      })
    }
  },
  data () {
    return {
      loadingMessages: false,
      fields: [
          { key: "geraetekennung", label: "Name", sortable: true },
          // { key: "id", sortable: true },
          { key: "benutzerId", label: "Benutzer", sortable: true, formatter: value => {
              let benutzer = this.alleBenutzer.find(obj => obj.id === value);
              return benutzer.vorname + " " + benutzer.name
            }},
          { key: "geraetetypId", label: "Gerätetyp", sortable: true, formatter: value => { return (this.geraetetypen.find(obj => obj.id === value)).titel} },
          { key: "sigfoxDeviceId", label: "Device Id", sortable: true},
          { key: "messages", label: "Nachrichten"}
        ]
    }
  },
  mounted () {
    this.fetchAlleGeraete()

  }
}
</script>

<style>

</style>
